export async function useFallbackSeo() {
  const { data: settings, suspense } = useSettings()

  await suspense()

  const route = useRoute()

  const { url: root } = useSiteConfig()

  const ogDescription = computed(() => settings.value?.seo?.description)
  const ogImage = computed(() => settings.value?.some?.image)

  useSeoMeta({
    description: ogDescription,
    ogDescription,
    ogLocale: 'no',
    ogSiteName: COMPANY_NAME,
    ogUrl: computed(() => root + route.path),
    ogImage,
    twitterCard: 'summary_large_image',
    twitterDescription: ogDescription,
    twitterImage: ogImage,
    twitterImageAlt: computed(() => settings.value?.seo?.title),
    twitterSite: `@${COMPANY_NAME}`,
  })
}
